export default "__VITE_ASSET__rHnWsQsf__"